export enum Job {
    FINANCIAL_ENGINEER = 'Financial engineer',
    DELEGATE_CONTRACTING_AUTHORITY = 'Delegate contracting authority',
}
  